import { useDatabase } from "@nozbe/watermelondb/hooks";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { CountProductModalRootParamList } from "../../../../types";
import Product from "../../../../utilities/data/model/Product";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";
import { ProductFormActionsContext } from "../../../products/components/ProductForm/context";
import { CreateProductRootScreen } from "../../../products/screens/CreateProductRootScreen";
import { CountNonProductModalScreen } from "../CountNonProductModalScreen";
import { CountProductModalScreen } from "../CountProductModalScreen";
import { CountProductModalRootProvider } from "../../components";
import { useCurrentCountContext } from "../../../../utilities/stock-count/hooks";

export const CountProductModalRootScreen = () => {
  const navigation =
    useNavigation<NavigationProp<CountProductModalRootParamList>>();

  const { fetchAndSyncEntity } = useSetupAllStartupEntities();
  const database = useDatabase();
  const { stockCount } = useCurrentCountContext();
  const Drawer = createStackHeaderNavigator<CountProductModalRootParamList>();

  return (
    <CountProductModalRootProvider stockCountId={stockCount.id}>
      <ProductFormActionsContext.Provider
        value={{
          onAfterAddProduct: async (product) => {
            try {
              await fetchAndSyncEntity("products");

              const newProduct = await database
                .get<Product>("products")
                .find(product.id);

              navigation.reset({
                index: 0,
                routes: [
                  {
                    name: "CountProductModalScreen",
                    params: {
                      productId: newProduct.id,
                    },
                  },
                ],
              });
            } catch (err) {
              console.log(err);
            }
          },
        }}
      >
        <Drawer.Navigator
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <ModalCloseButton type="Close" />,
            title: "",
          }}
        >
          <Drawer.Screen
            name="CountProductModalScreen"
            component={CountProductModalScreen}
          />
          <Drawer.Screen
            name="CountNonProductModalScreen"
            component={CountNonProductModalScreen}
          />
          <Drawer.Group
            screenOptions={{
              headerShown: false,
            }}
          >
            <Drawer.Screen
              name="CreateProductRootScreen"
              component={CreateProductRootScreen}
            />
          </Drawer.Group>
        </Drawer.Navigator>
      </ProductFormActionsContext.Provider>
    </CountProductModalRootProvider>
  );
};
